var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "partner-link-form__button" },
    [
      _c(
        "button-control",
        {
          staticClass: "_copy",
          on: {
            click: function($event) {
              return _vm.copyText(_vm.copyValue)
            }
          }
        },
        [
          _c("icon", {
            staticClass: "partner-link-form__button-icon",
            attrs: { name: "copy", width: "16", height: "16" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.isCopied ? "Скопировано" : "Копировать") +
              "\n  "
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }